export const SET_DETAILS = 'app/Storage/SET_DETAILS';
export const REMOVE_DETAIL = 'app/Storage/REMOVE_DETAIL';
export const CLEAR_ALL_DETAILS = 'app/Storage/CLEAR_ALL_DETAILS';
